import * as React from 'react';

import { Image } from "expo-image"

function DImage(op) {
    return <Image source={{ uri:op.uri}} style={{ width: op?.width ? op?.width :  110, height: 150, alignSelf: "center", borderRadius: 10 }} />

}
export default React.memo(DImage)